import { EinstellungenSheetContext } from '@/domain/controlling/pages/Umsatzplanung/Einstellungen/EinstellungenSheetContext/EinstellungenSheetContext';
import { ReactNode, useState } from 'react';

export function EinstellungenSheetContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);

  return (
    <EinstellungenSheetContext.Provider value={{ open, setOpen }}>
      {children}
    </EinstellungenSheetContext.Provider>
  );
}
